<template>
  <span>
    <slot :formErrors="errors"></slot>
  </span>
</template>

<script>
import Schema from 'async-validator';

export default {
  props: {
    values: Object,
    rules: Object,
  },
  data() {
    return {
      errors: {},
    };
  },
  methods: {
    async validate(field = '') {
      try {
        const rules = field ? { [field]: this.rules[field] } : this.rules;
        const data = field ? { [field]: this.values[field] } : this.values;

        const validator = new Schema(rules);
        await validator.validate(data);
        this.errors = {};
        return true;
      } catch (error) {
        this.errors = this.normalizeError(error);
        return false;
      }
    },

    reset() {
      this.errors = {};
    },

    normalizeError(error) {
      return Object.keys(error.fields).reduce((final, next) => {
        const errorData = error.fields[next][0];
        return { ...final, [next]: errorData };
      }, {});
    },
  },
};
</script>

<style>
</style>